/**
 * This works around a strange property of Math.round:
 *   Math.round(-0.5) === 0
 * The above should evaluate to -1 instead.
 */
export function trueRound(num) {
  const modifier = num < 0 ? -1 : 1
  return Math.round(Math.abs(num)) * modifier
}
